// @core/api/endpoints/product/update_marketplace_metadata.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MarketplaceMetadataResponse,
  UpdateMarketplaceMetadataRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Update marketplace metadata
 * Updates marketplace listing information for a product: screenshots, descriptions, demo URL, tags.
 */
export async function UpdateMarketplaceMetadata(
  product_id: string,
  data: UpdateMarketplaceMetadataRequest,
  options?: RequestOptions
): Promise<MarketplaceMetadataResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/marketplace`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.put<MarketplaceMetadataResponse>(requestPath, data, requestOptions);
}
